/**
 * Meeting Services Module
 * Exports all meeting management services and factory functions
 */
// Service exports (one per controller)
export * from './MeetingService';
export * from './MeetingStatusService';
export * from './MeetingTypeService';
export * from './MeetingVenueService';
export * from './MeetingAttendeeService';
export * from './MeetingAttendanceStatusService';
export * from './MeetingSetupService';
export * from './MeetingRequestService';
export * from './MeetingCommentService';
export * from './MeetingFileService';
export * from './SetupInMeetingService';
export * from './RequestInMeetingService';
export * from './LocationVenueRequestService';
export * from './LocationVenueSetupService';
// Service imports for factory
import { MeetingService } from './MeetingService';
import { MeetingStatusService } from './MeetingStatusService';
import { MeetingTypeService } from './MeetingTypeService';
import { MeetingVenueService } from './MeetingVenueService';
import { MeetingAttendeeService } from './MeetingAttendeeService';
import { MeetingAttendanceStatusService } from './MeetingAttendanceStatusService';
import { MeetingSetupService } from './MeetingSetupService';
import { MeetingRequestService } from './MeetingRequestService';
import { MeetingCommentService } from './MeetingCommentService';
import { MeetingFileService } from './MeetingFileService';
import { SetupInMeetingService } from './SetupInMeetingService';
import { RequestInMeetingService } from './RequestInMeetingService';
import { LocationVenueRequestService } from './LocationVenueRequestService';
import { LocationVenueSetupService } from './LocationVenueSetupService';
/**
 * Create all meeting services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all meeting service instances
 */
export function createMeetingServices(http, config) {
    return {
        meeting: new MeetingService(http, config),
        meetingStatus: new MeetingStatusService(http, config),
        meetingType: new MeetingTypeService(http, config),
        meetingVenue: new MeetingVenueService(http, config),
        meetingAttendee: new MeetingAttendeeService(http, config),
        meetingAttendanceStatus: new MeetingAttendanceStatusService(http, config),
        meetingSetup: new MeetingSetupService(http, config),
        meetingRequest: new MeetingRequestService(http, config),
        meetingComment: new MeetingCommentService(http, config),
        meetingFile: new MeetingFileService(http, config),
        setupInMeeting: new SetupInMeetingService(http, config),
        requestInMeeting: new RequestInMeetingService(http, config),
        locationVenueRequest: new LocationVenueRequestService(http, config),
        locationVenueSetup: new LocationVenueSetupService(http, config),
    };
}
//# sourceMappingURL=index.js.map